import { Controller } from "@hotwired/stimulus"

// Removes its element (a flash message) when the close button is pressed.
export default class extends Controller {
  close() {
    this.element.remove()
  }
}
